function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es7.object.entries.js";
import "core-js/modules/es6.array.is-array.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import FallbackErrorPage from './fallbackErrorPage.vue';
import FallbackEmpty from './fallbackEmpty.vue';
import { logException } from '../../sentry';
var isObjectEmpty = function isObjectEmpty(obj) {
  return Object.entries(obj).length === 0 && obj.constructor === Object;
};
var warn = function warn(msg) {
  return console.warn(msg);
};
// https://github.com/posva/vue-promised/blob/master/src/index.js
var convertVNodeArray = function convertVNodeArray(h, wrapperTag, nodes) {
  // for arrays and single text nodes
  if (nodes.length > 1 || !nodes[0].tag) {
    return h(wrapperTag, {}, nodes);
  }
  return nodes[0];
};
export default {
  name: 'ErrorBoundary',
  props: {
    fallBack: {
      type: [Object, Boolean],
      "default": function _default() {
        return FallbackErrorPage;
      }
    },
    onError: {
      type: Function,
      "default": null
    },
    params: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    stopPropagation: {
      type: Boolean,
      "default": true
    },
    tag: {
      type: String,
      "default": 'span'
    }
  },
  data: function data() {
    return {
      err: '',
      info: '',
      hasError: null
    };
  },
  computed: {
    fallbackComponent: function fallbackComponent() {
      return this.fallBack ? this.fallBack : FallbackEmpty;
    }
  },
  errorCaptured: function errorCaptured(err, vm) {
    var info = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    this.hasError = true;
    this.err = err;
    this.info = info;
    this.element = vm.$vnode.tag;

    // Send error to Sentry
    logException(this.err, {
      level: 'fatal',
      tags: {
        boundary: true
      }
    });
    this.$emit('errorCaptured', {
      err: err,
      vm: vm,
      info: info
    });
    if (this.onError) {
      this.onError(err, vm, info);
    }
    if (this.stopPropagation) {
      return false;
    }
  },
  render: function render(h) {
    var fallback = this.fallbackComponent;
    var content = this.$slots["default"];
    var isScoped = this.$scopedSlots.boundary;
    var scopedSlot;
    if (isScoped) {
      scopedSlot = this.$scopedSlots.boundary({
        hasError: this.hasError,
        err: this.err,
        info: this.info,
        element: this.element
      });
    }
    var fallbackOrScoped = isScoped ? scopedSlot : h(fallback, {
      props: _objectSpread(_objectSpread({}, this.params), {}, {
        error: this.err,
        info: this.info,
        element: this.element
      })
    });
    if (this.hasError) {
      return Array.isArray(fallbackOrScoped) ? convertVNodeArray(h, this.tag, fallbackOrScoped) : fallbackOrScoped;
    }
    if (isScoped) {
      if (!this.$scopedSlots.boundary()) {
        warn('ErrorBoundary component must have child components.');
        return null;
      }
      return Array.isArray(scopedSlot) ? convertVNodeArray(h, this.tag, scopedSlot) : scopedSlot;
    }
    if (isObjectEmpty(this.$slots)) {
      warn('ErrorBoundary component must have child components.');
      return null;
    }
    return Array.isArray(content) ? convertVNodeArray(h, this.tag, content) : content;
  }
};